export const DEFAULT_CURRENCY = '$';

export const DEFAULT_COUNTRY = 'US';

export const PASSWORD_MIN_LENGTH = 6;

export const PASSWORD_MAX_LENGTH = 12;

export const GENDERS = { FEMALE: 'female', MALE: 'male' };

export const WEB_USER_SOURCE = 'web-cabinet';
